import { useState, useEffect, Dispatch, SetStateAction } from 'react';
import { safeJSONParse } from '../../../../../@utils/jsonParse';

function useLocalStorage<T>(key: string, defaultValue: T): [T, Dispatch<SetStateAction<T>>] {
    const [value, setValue] = useState(() => {
        const storedValue = window.localStorage.getItem(key);
        return storedValue ? safeJSONParse(storedValue, defaultValue) : defaultValue;
    });

    const setLocalStorage = (key: string, value: T) => {
        try {
            window.localStorage.setItem(key, JSON.stringify(value));
        } catch (err) {
            console.error('setLocalStorage', err);
        }
    };

    useEffect(() => {
        const onStorageChange = (event: StorageEvent) => {
            if (event.key === key) {
                if (event.newValue !== null) {
                    setValue(safeJSONParse(event.newValue, defaultValue));
                } else {
                    // 当 localStorage 的值被删除时，设置为默认值
                    if (defaultValue === value) {
                        setLocalStorage(key, value);
                    } else {
                        setValue(defaultValue);
                    }
                }
            }
        };

        window.addEventListener('storage', onStorageChange);

        return () => {
            window.removeEventListener('storage', onStorageChange);
        };
    }, [key]);

    useEffect(() => {
        try {
            setLocalStorage(key, value);
        } catch (error) {
            console.error('setLocalStorage', error);
        }
    }, [key, value]);

    return [value, setValue];
}

export { useLocalStorage };
